var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 2350"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-1_svg__a",
    x1: -0.31,
    y1: 1176.57,
    x2: 1918.7,
    y2: 1176.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76c6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5cd2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3be1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21edc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0ff5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#04faae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fcac"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-1_svg__a)",
    d: "M-.31-1.81H1918.7v2356.75H-.31z"
  })));
}
export default __webpack_public_path__ + "ed7aa6ca6d76ec8dc48a8a64e2de0ba2.svg";
export { SvgBackground1 as ReactComponent };